import React from 'react';
import { useTranslation } from 'react-i18next';
import Select from '../../../Select';
import type { MetaParagraphsContentTypes } from '../../../../types/uncinc_profile/paragraphs';
import { contentTypeSortOptions } from '../config';

interface MetaSortingProps {
  contentType: MetaParagraphsContentTypes;
  activeSort: string | null;
  onSortChange: (sortValue: string | null) => void;
}

const MetaSorting: React.FC<MetaSortingProps> = ({ contentType, activeSort, onSortChange }) => {
  const { t } = useTranslation();
  const sortOptions = contentTypeSortOptions[contentType];

  // If no sort options are defined for this content type, don't render
  if (!sortOptions) {
    return null;
  }

  const handleSortChange = (selectedOption: any) => {
    onSortChange(selectedOption?.value);
  };

  return (
    <Select
      id="sort-select-search"
      value={activeSort}
      defaultValue={null}
      selectedOption={sortOptions.find((option: any) => option.value === activeSort)}
      options={sortOptions}
      handleChange={handleSortChange}
      placeholder={t('avo.sort_placeholder')}
      isSearchable={false}
    />
  );
};

export default MetaSorting;
